import { cn } from '@/lib/utils';
import { forwardRef, type ReactNode } from 'react';

/**
 * Generic horizontal-scrolling container for a row of tabs. Keeps tabs on a
 * single line on narrow screens (scroll instead of wrapping to multiple lines).
 * Shared by every tab strip (`RouteTabs`, `PlanningTabNav`, …) so the mobile
 * behaviour is identical everywhere. Tab items keep their own styling; this only
 * owns the scroll behaviour. Items should be `shrink-0 whitespace-nowrap`.
 */
export const TabScroller = forwardRef<
  HTMLElement,
  { children: ReactNode; ariaLabel: string; className?: string }
>(({ children, ariaLabel, className }, ref) => (
  <div className='max-w-full min-w-0 overflow-x-auto overscroll-x-contain [scrollbar-width:none] [&::-webkit-scrollbar]:hidden'>
    <nav ref={ref} className={cn('flex w-max gap-1', className)} aria-label={ariaLabel}>
      {children}
    </nav>
  </div>
));
TabScroller.displayName = 'TabScroller';
